export default (node) => {
  const textureGuideModalButton = node;
  const textureGuideModal = node.nextElementSibling;

  const modalCloseButton = textureGuideModal.querySelector(
    '[data-texture-guide-close]'
  );

  const openModal = () => {
    textureGuideModal.classList.remove('hidden');
    textureGuideModal.classList.add('flex');
  };

  const closeModal = () => {
    textureGuideModal.classList.remove('flex');
    textureGuideModal.classList.add('hidden');
  };

  const init = () => {
    textureGuideModalButton.addEventListener('click', openModal);
    modalCloseButton.addEventListener('click', closeModal);
    textureGuideModal.addEventListener('click', (e) => {
      if (e.target === textureGuideModal) {
        closeModal();
      }
    });
  };

  init();
};
